import React from 'react';
import PropTypes from 'prop-types';
import { numFormat } from '@/pages/agency/utils/util';

class Money extends React.PureComponent {
  static propTypes = {
    value: PropTypes.number,
  }

  render() {
    const { value } = this.props;
    if (typeof value !== 'number' || isNaN(value)) {
      return null;
    }

    return <span className={'Money'}>{numFormat(value, 2)} 元</span>;
  }
}

export default Money;
